import { render, staticRenderFns } from "./CheckBoxes.vue?vue&type=template&id=f04932ca&"
import script from "./CheckBoxes.vue?vue&type=script&lang=js&"
export * from "./CheckBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports